"use client";

import React from "react";
import dynamic from "next/dynamic";
import { useMediaQuery } from "usehooks-ts";

import { useDispatch, useSelector } from "@/redux/hooks";
import { cleanup, launch } from "@/redux/slices/weedfetti";
import { use420Timeout } from "hooks/use420Timeout";

const WeedfettiParticles = dynamic(() => import("./WeedfettiParticles"));

export function WeedfettiCannon() {
  const dispatch = useDispatch();
  const prefersReducedMotion = useMediaQuery("(prefers-reduced-motion)");
  const instances = useSelector((state) => state.weedfetti.instances);

  use420Timeout(() => {
    if (
      !prefersReducedMotion &&
      typeof document !== "undefined" &&
      document.visibilityState === "visible"
    ) {
      dispatch(
        launch({
          colors: ["#017C6B", "#80BEB5", "#FFCD00", "#5C068C"],
          theme: "fourtwenty",
        }),
      );
    }
  });

  return (
    <>
      {instances.map(({ id, colors, theme }) => (
        <WeedfettiParticles
          key={id}
          colors={colors}
          onConfettiComplete={() => cleanup(id)}
          theme={theme}
        />
      ))}
    </>
  );
}
